// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"stem-splitter-categories-bar_wrapper__QsFw3"};